import { render } from "./DetailRow.vue?vue&type=template&id=4054cccf"
import script from "./DetailRow.vue?vue&type=script&lang=js"
export * from "./DetailRow.vue?vue&type=script&lang=js"

import exportComponent from "/Users/herianto/Projects/yeu-logistik/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/PurchaseOrdersRecv/DetailRow.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4054cccf"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4054cccf', __exports__)) {
    console.log('reload')
    api.reload('4054cccf', __exports__)
  }
  
  module.hot.accept("./DetailRow.vue?vue&type=template&id=4054cccf", () => {
    console.log('re-render')
    api.rerender('4054cccf', render)
  })

}


export default __exports__